import { Action } from '@ngrx/store';
import { CalendarFilter, CalendarFiltersState } from './state';

export interface FilterChange {
  name: string;
  value: CalendarFilter;
}

export interface FilterClear {
  name: string;
  subFilterName: string;
}

export enum CalendarFiltersActionTypes {
  Set = '[Calendar Filters] Set',
  SetMany = '[Calendar Filters] SetMany',
  SetAll = '[Calendar Filters] SetAll',
  Reset = '[Calendar Filters] Reset',
  ClearFilter = '[Calendar Filters] Clear Filter'
}

export class CalendarFilterSet implements Action {
  public readonly type = CalendarFiltersActionTypes.Set;
  constructor(public payload: FilterChange) {}
}

export class CalendarFilterSetMany implements Action {
  public readonly type = CalendarFiltersActionTypes.SetMany;
  constructor(public payload: FilterChange[]) {}
}

export class CalendarFilterSetAll implements Action {
  public readonly type = CalendarFiltersActionTypes.SetAll;
  constructor(public payload: CalendarFiltersState) {}
}

export class CalendarFilterReset implements Action {
  public readonly type = CalendarFiltersActionTypes.Reset;
}
export class CalendarFilterClear implements Action {
  public readonly type = CalendarFiltersActionTypes.ClearFilter;
  constructor(public payload: FilterClear) {}
}

export type CalendarFiltersActionUnion =
  | CalendarFilterReset
  | CalendarFilterSetMany
  | CalendarFilterSetAll
  | CalendarFilterSet
  | CalendarFilterClear;
